import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JSChartingService } from './jscharting.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    JSChartingService
  ]
})
export class JSChartingModule { }